<template>
  <v-container id="ingredients" fluid tag="section">
    <base-v-component :heading="$t('ingredients-title')" :subtitle="$t('ingredients-subtitle')" />

    <v-autocomplete
      v-model="searchItem"
      :search-input.sync="search"
      :loading="searchLoading"
      :items="searchItems"
      item-text="inciName"
      item-value="cosingRef"
      :label="$t('search')"
      flat
      solo-inverted
      hide-no-data
      hide-selected
      hide-details
      return-object
    >
      <template
        slot="item"
        slot-scope="data"
      >
        <v-icon small class="mr-2" v-if="data.item.hasEvaluation">mdi-check</v-icon>
          {{ data.item.inciName }} ({{data.item.casNumber}})</template>
    </v-autocomplete>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="ingredients"
        :loading="fetchLoading"
        :loading-text="$t('ingredients-loading')"
        sort-by="updateDate"
        sort-desc
        :options.sync="tableOptions"
        class="elevation-1 pa-3 clickable"
        :dense="false"
        :calculate-widths="true"
        :hide-default-footer="true"
        :disable-pagination="true"
        @click:row="onRowClick"
      >
        <template v-slot:item.updated="{ item }">{{ $moment(new Date(item.updated)).format("YYYY-MM-DD") }}</template>
        <template v-slot:item.notes="{ item }">
          
          <v-tooltip v-if="item.hasEvaluation" bottom>
            <template #activator="{ on }">
              <v-icon v-on="on" small class="mr-2">mdi-check</v-icon>
            </template>
            <span>Has evaluation</span>
          </v-tooltip>
          <!--
          <v-tooltip v-if="item.evaluationId && !item.hasAssessment" bottom>
            <template #activator="{ on }">
              <v-icon v-on="on" small class="mr-2" color="accent">mdi-exclamation-thick</v-icon>
            </template>
            <span>Evaluated, but lacks safety assessment</span>
          </v-tooltip>
          -->
          
          <v-tooltip v-if="isProhibited(item)" bottom>
            <template #activator="{ on }">
              <v-icon v-on="on" small class="mr-2" color="red">mdi-alert</v-icon>
            </template>
            <span>Ingredient is prohibited (Annex 2)</span>
          </v-tooltip>
          <v-tooltip v-if="isRestricted(item)" bottom>
            <template #activator="{ on }">
              <v-icon v-on="on" small class="mr-2">mdi-alert-circle-outline</v-icon>
            </template>
            <span>Ingredient has restriction (Annex 3)</span>
          </v-tooltip>
        </template>
        <template v-slot:footer>
          <section class="my-6 text-center">
              <v-btn
                v-if="cosing.length>ingredients.length && !fetchLoading"
                color="primary"
                text
                @click="onQueryIngredients()"
                :disabled="fetchLoading || cosing.length<=ingredients.length"
              >
                Load more
              </v-btn>
          </section>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import Fuse from 'fuse.js'

export default {
  name: "Ingredients",

  data: () => ({
    headers: [
      {
        text: "",
        value: "evaluated",
        sortable: false,
        width: "1%",
        align: "start",
      },
      { text: "INCI Name", value: "inciName", width: "40%" },
      { text: "CAS", value: "casNumber", width: "23%" },
      { text: "Updated", value: "updateDate", width: "12%" },
      {
        text: "",
        value: "notes",
        sortable: false,
        width: "10%",
        align: "right",
      },
    ],
    
    sortedBy: 'updateDate',
    sortedDesc: true,
    tableOptions: {},
    limit: 10,

    fetchLoading: false,

    search: "",
    searchItems: [],
    searchConsolidated: [],
    searchLoading: false,
    
    dialogConfirmDelete: false,

    fuse: null,
    fuseOptions: {
      keys: ['inciName', 'casNumber']
    }
  }),

  created() {
    if (this.activeProject && this.activeProject.id) {
      if (this.ingredients.length<this.limit) {
        this.onQueryIngredients();
      }
    }

    this.fuse = new Fuse(this.cosing, this.fuseOptions)
  },

  watch: {
    tableOptions: {
      handler () {
        if (this.activeProject && this.activeProject.id) {
          if (this.tableOptions && this.tableOptions.sortBy && this.tableOptions.sortDesc) {
            if (this.tableOptions.sortBy[0] != this.sortedBy || this.tableOptions.sortDesc[0] != this.sortedDesc) {
              this.sortedBy = this.tableOptions.sortBy[0];
              this.sortedDesc = this.tableOptions.sortDesc[0]
              this.clearFetch();
            }
          }
        }
      },
      deep: true,
    },
    activeProject: function () {
      this.clearFetch();
    },
    search (val) {
      val && this.queryCosing(val)
    },
  },

  computed: {
    activeProject() {
      return this.$store.getters["projects/getActiveProject"];
    },
    ingredients() {
      return this.$store.getters["ingredients/getIngredients"];
    },
    cosing() {
      return this.$store.getters["ingredients/getCosing"];
    },
    concatIngredients() {
      return this.ingredients.concat(this.customIngredients);
    },
    searchItem: {
      set(item) {
        this.onRowClick(item)
      },
      get() {
        return null;
      }
    },
  },

  methods: {
    queryIngredients() {
      this.fetchLoading = true;
      this.$store.dispatch('ingredients/queryIngredients', { projectId: this.activeProject.id, options: this.tableOptions })
        .then(() => {
          this.fetchLoading = false;
        })
        .catch((error) => {
          console.log('error in queryIngredients', error)
          this.fetchLoading = false;
        })
    },
    async clearFetch() {
      await this.$store.dispatch("ingredients/clearIngredients")
      this.onQueryIngredients();
    },
    onQueryIngredients() {
      if (this.activeProject && this.activeProject.id && this.cosing.length>this.ingredients.length) {
        this.fetchLoading = true;
        setTimeout(() => {  this.queryIngredients(); }, 1000);
      }
    },
    queryCosing(search) {
      if (search && search.length >= 2) {
        const res = this.fuse.search(search).slice(0,6)
        this.searchItems = res.map((obj) => { return obj.item });
      } else {
        this.searchItems = [];
      }
    },
    isProhibited (item) {
      return this.$store.getters["ingredients/isProhibited"](item);
    },
    isRestricted (item) {
      return this.$store.getters["ingredients/isRestricted"](item);
    },
    async hasEvaluation (item) {
      return await this.$store.dispatch('projectIngredients/hasEvaluation', { projectId: this.activeProject.id, item: item })
    },
    onRowClick(item) {
      this.onEditItem(item);
    },
    onCreateItem() {
      if (this.activeProject.id) {
        this.$router.push({ name: "ingredients.create" });
      } else {
        this.$notify({
          group: "base",
          type: "error",
          title: "No active project selected",
          text: "Select a project before creating an ingredient.",
        });
      }
    },
    onEditItem(item) {
      this.$router.push({
          name: "ingredients.view",
          params: { id: item.reference },
        });
      /*
      if (item.evaluationId) {
        this.$router.push({
          name: "evaluations.edit",
          params: { id: item.evaluationId },
        });
      } else {
        this.$router.push({
          name: "ingredients.view",
          params: { id: item.reference },
        });
      }
      */
    },
    customFilter(item, queryText) {
      const textOne = item.inciName.toLowerCase();
      const textTwo = item.casNumber.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
  },
};
</script>
